import DataItem from 'components/DataItem';
import AccommodationTable from 'components/quoteBooking/AccommodationTable';
import { displayISODateTime } from 'shared/helpers/common';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';

export default function AccommodationItem({
  accommodation,
  isPackage = false,
}) {
  const { name, resort, startDate, endDate, boardBasis, address, rooms } =
    accommodation;
  const roomList = rooms || [];

  const { whiteLabelSettings: { primaryColour } = {} } =
  useWhiteLabelSettings();

  const backgroundStyle = {
    backgroundColor: primaryColour || DEFAULT_PRIMARY_COLOUR,
  };

  return (
    <div className="pb-8 bg-white">
      <div
        style={backgroundStyle}
        className="mt-[40px] rounded-t-lg text-white text-xl font-bold"
      >
        <div className="p-4 text-[24px] font-medium">
          <div>{name}</div>
        </div>
      </div>
      <div className="flex flex-wrap bg-white pt-2 pb-3 px-4 md:px-8">
        <DataItem label="Resort" value={resort} />
        <DataItem label="Accommodation name" value={name} />
        <DataItem label="Check in" value={displayISODateTime(startDate)} />
        <DataItem label="Check out" value={displayISODateTime(endDate)} />
        <DataItem label="Board" value={boardBasis} />
        <DataItem label="Address Line 1" value={address?.address1} />
        <DataItem label="Address Line 2" value={address?.address2} />
        <DataItem label="Address Line 3" value={address?.address3} />
        <DataItem label="City" value={address?.city} />
        <DataItem label="Country" value={address?.country} />
      </div>
      <AccommodationTable roomList={roomList} isPackage={isPackage} />
    </div>
  );
}
